<template>
  <el-form
    style="margin-top: 16px"
    :model="properties"
    ref="form"
    label-width="140px"
  >
    <template v-for="key in keys">
      <el-form-item
        :key="key"
        v-if="enabled(key)"
        :label="label(key)"
        :rules="rules(key)"
        :prop="key"
      >
        <el-input
          v-if="htmlField(key) === 'text'"
          v-model="properties[key]"
        ></el-input>

        <el-select
          v-if="htmlField(key) === 'select'"
          v-model="properties[key]"
          placeholder="Please select one option"
        >
          <el-option
            v-if="!required(key)"
            label="Please select one option"
            value
          />
          <el-option
            v-for="choice in choices(entities, entity, key)"
            :key="choice.value"
            :label="choice.label"
            :value="choice.value"
          ></el-option>
        </el-select>

        <el-input-number
          v-if="htmlField(key) === 'number'"
          v-model="properties[key]"
        ></el-input-number>

        <el-color-picker
          v-if="htmlField(key) === 'color'"
          v-model="properties[key]"
        ></el-color-picker>

        <div
          v-if="help(key)"
          class="leading-7 text-xs font-medium text-gray-500"
        >
          {{ help(key) }}
        </div>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-entity-form-property',

  mounted() {
    if (this.keys) {
      this.keys.forEach((key) => {
        const referenceKey = `tooltip${key}`;
        if (
          this.$refs[referenceKey] &&
          this.$refs[referenceKey].referenceElm
        ) {
          this.$refs[
            referenceKey
          ].referenceElm.setAttribute('tabindex', -1);
        }
      });
    }

    this.$store.commit(
      'builder/entityCurrent/propertyForm',
      this.$refs.form,
    );
  },

  computed: {
    ...mapGetters({
      entity: 'builder/entityCurrent/current',
      entities: 'builder/entityCurrent/list',
      keys: 'builder/entityProperty/keys',
      enabled: 'builder/entityProperty/enabled',
      required: 'builder/entityProperty/required',
      label: 'builder/entityProperty/label',
      htmlField: 'builder/entityProperty/htmlField',
      help: 'builder/entityProperty/help',
      choices: 'builder/entityProperty/choices',
    }),

    properties() {
      if (!this.entity) {
        return {};
      }

      return this.entity.properties;
    },

    rules() {
      return (key) => {
        if (!this.required(key)) {
          return null;
        }

        return {
          required: true,
          message: `${this.label(key)} is required`,
          trigger: 'blur',
        };
      };
    },
  },
};
</script>

<style></style>
